import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export type GearBrief = {
  slug: string;
  category: string;
  brand: string;
  name: string;
  price_eur: number | null;
  price_tier: "low" | "mid" | "premium";
  image_url: string | null;
  is_sponsored: boolean;
  tags: string[];
  recommended_distances: string[];
};

export type GearDetail = GearBrief & {
  description: string | null;
  source_url: string | null;
  affiliate_url: string | null;
};

export type GearListOut = {
  items: GearBrief[];
  total: number;
};

export type CategoriesOut = {
  categories: { category: string; count: number }[];
  price_tiers: string[];
};

export type GearFilters = {
  category?: string;
  brand?: string;
  price_tier?: string;
  price_max?: number;
  q?: string;
  recommended_for_distance?: string;
  sort?: "default" | "price_asc" | "price_desc";
};


export function useGearCategories() {
  return useQuery<CategoriesOut>({
    queryKey: ["gear-categories"],
    queryFn: async () =>
      (await api.get<CategoriesOut>("/athlete/gear/categories")).data,
    staleTime: 60 * 60_000,
  });
}

export function useGear(filters: GearFilters) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v).length > 0) {
      params.set(k, String(v));
    }
  });
  const qs = params.toString();
  return useQuery<GearListOut>({
    queryKey: ["gear", qs],
    queryFn: async () =>
      (await api.get<GearListOut>(`/athlete/gear${qs ? `?${qs}` : ""}`)).data,
    staleTime: 5 * 60_000,
  });
}

export function useGearItem(slug: string | null) {
  return useQuery<GearDetail>({
    queryKey: ["gear-item", slug],
    queryFn: async () =>
      (await api.get<GearDetail>(`/athlete/gear/${slug}`)).data,
    enabled: slug !== null,
    staleTime: 5 * 60_000,
  });
}
